import { useState } from "react";
import {
  ACCEPTED_FILE_EXTENSIONS,
  ACCEPTED_MIME_TYPES,
  MAX_FILE_SIZE_BYTES,
} from "../../../config";

export const hasAcceptedFileMimeType = (file: File | DataTransferItem) =>
  !file.type || ACCEPTED_MIME_TYPES.has(file.type);

const hasAcceptedFileType = (file: File) => {
  const lowerCaseFileName = file.name.toLowerCase();
  const hasAcceptedExtension = ACCEPTED_FILE_EXTENSIONS.some((extension) =>
    lowerCaseFileName.endsWith(extension)
  );
  return hasAcceptedExtension && hasAcceptedFileMimeType(file);
};

export enum ValidationErrorType {
  UnsupportedFileType = "UnsupportedFileType",
  FileTooLarge = "FileTooLarge",
}

export const useValidation = () => {
  const [validationErrorType, setValidationErrorType] = useState<
    ValidationErrorType | undefined
  >(undefined);

  const validateFile = (file: File) => {
    if (!hasAcceptedFileType(file)) {
      return {
        valid: false,
        type: ValidationErrorType.UnsupportedFileType,
      };
    }

    if (file.size > MAX_FILE_SIZE_BYTES) {
      return {
        valid: false,
        type: ValidationErrorType.FileTooLarge,
      };
    }

    return { valid: true, type: undefined };
  };

  const clearValidationError = () => setValidationErrorType(undefined);

  return {
    validateFile,
    validationErrorType,
    setValidationErrorType,
    clearValidationError,
  };
};
